import axios from './axios'

let instance = axios()

export default {
    // get(url,headers) {
    //     let options = {}
    //
    //     if (headers) {
    //         options.headers = headers
    //     }
    //     return instance.get(url, options)
    // },

    //获取token
    // get_access_token(data,headers)
    // {
    //     let options = {}
    //
    //     if (headers) {
    //         options.headers = headers
    //     }
    //
    //     return instance.post('http://www.shop.com/oauth/token', data, options)
    // },

    //获取首页数据
    all_sales_amount(data,headers) {

        let options = {}

        if (headers) {
            options.headers = headers
        }

        return instance.post('/summary/all_sales_amount', data, options)
    },


    all_sales_amount1(data,headers) {

        let options = {}

        if (headers) {
            options.headers = headers
        }

        return instance.post('/summary/all_sales_amount1', data, options)
    },
    zq_mouth_ranking(data,headers){
        let options = {}


        if (headers) {
            options.headers = headers
        }

        return  instance.post('/zq/mouth_ranking', data, options)
    },

    zgu_mouth_ranking(data,headers){
        let options = {}


        if (headers) {
            options.headers = headers
        }

        return  instance.post('/zgu/mouth_ranking', data, options)
    },

    zga_mouth_ranking(data,headers){
        let options = {}


        if (headers) {
            options.headers = headers
        }

        return  instance.post('/zga/mouth_ranking', data, options)
    },

    zq_broken_line(data,headers){

        let options = {}

        if (headers) {
            options.headers = headers
        }

        return  instance.post('/zq/broken_line', data, options)
    },
    zgu_broken_line(data,headers){

        let options = {}

        if (headers)
        {
            options.headers = headers
        }

        return  instance.post('/zgu/broken_line', data, options)
    },

    zga_broken_line(data,headers){
        let options = {}

        if (headers)
        {
            options.headers = headers
        }

        return  instance.post('/zga/broken_line', data, options)
    },

    zq_fp_ranking(data,headers){
        let options = {}

        if (headers)
        {
            options.headers = headers
        }

        return  instance.post('/zq/fp_ranking', data, options)
    },

    zq_fp_ranking1(data,headers){
        let options = {}

        if (headers)
        {
            options.headers = headers
        }

        return  instance.post('/zq/fp_ranking1', data, options)
    },

    zgu_fp_ranking(data,headers){
        let options = {}

        if (headers)
        {
            options.headers = headers
        }

        return  instance.post('/zgu/fp_ranking', data, options)
    },


    zga_fp_ranking(data,headers){
        let options = {}

        if (headers)
        {
            options.headers = headers
        }

        return  instance.post('/zga/fp_ranking', data, options)
    },

    zq_real_order(data,headers){
        let options = {}

        if (headers)
        {
            options.headers = headers
        }

        return  instance.post('/zq/real_order', data, options)
    },

    zgu_real_order(data,headers){
        let options = {}

        if (headers)
        {
            options.headers = headers
        }

        return  instance.post('/zgu/real_order', data, options)
    },

    logion(data,headers){
        let options = {}

        if (headers)
        {
            options.headers = headers
        }

        return  instance.post('http://zmd.qkvop.com/api/regulator/login', data, options)
    },

    zgu_area_count(data,headers){
        let options = {}

        if (headers)
        {
            options.headers = headers
        }

        return  instance.post('/zgu/area_count', data, options)
    },

    zga_real_order(data,headers)
    {
        let options = {}

        if (headers)
        {
            options.headers = headers
        }

        return  instance.post('/zga/real_order', data, options)
    },
    zq_company_list(data,headers){
        let options = {}

        if (headers)
        {
            options.headers = headers
        }

        return  instance.post('/zq/company_list', data, options)
    },
    zq_personal_list(data,headers){
        let options = {}

        if (headers)
        {
            options.headers = headers
        }

        return  instance.post('/zq/personal_list', data, options)
    },
    zq_area_summary(data,headers){
        let options = {}

        if (headers)
        {
            options.headers = headers
        }

        return  instance.post('/zq/area_summary', data, options)
    },
    zga_area_summary(data,headers){
        let options = {}

        if (headers)
        {
            options.headers = headers
        }

        return  instance.post('/zga/area_summary', data, options)
    },
    zga_area_num(data,headers){
        let options = {}

        if (headers)
        {
            options.headers = headers
        }

        return  instance.post('/zga/area_num', data, options)
    },

    zq_map(data,headers){
        let options = {}

        if (headers)
        {
            options.headers = headers
        }

        return  instance.post('/zq/map', data, options)
    },
    zq_map1(data,headers){
        let options = {}

        if (headers)
        {
            options.headers = headers
        }

        return  instance.post('/zq/map1', data, options)
    },
    zga_map(data,headers){
        let options = {}

        if (headers)
        {
            options.headers = headers
        }

        return  instance.post('/zga/map', data, options)
    },
    zgu_map(data,headers){
        let options = {}

        if (headers)
        {
            options.headers = headers
        }

        return  instance.post('/zgu/map', data, options)
    },
    zgu_summary(data,headers){
        let options = {}

        if (headers)
        {
            options.headers = headers
        }

        return  instance.post('/zgu/summary', data, options)
    },

    zq_summary(data,headers){
        let options = {}

        if (headers)
        {
            options.headers = headers
        }

        return  instance.post('/zq/summary', data, options)
    },
    zga_summary(data,headers){
        let options = {}

        if (headers)
        {
            options.headers = headers
        }

        return  instance.post('/zga/summary', data, options)
    },
    login(data,headers){
        let options = {}

        if (headers)
        {
            options.headers = headers
        }

        return  instance.post('/login/login', data, options)
    },

    zq_fp_summary(data,headers){
        let options = {}

        if (headers)
        {
            options.headers = headers
        }

        return  instance.post('/zq/fp_summary', data, options)
    },


    search_goods(data,headers)
    {
        let options = {}

        if (headers) {
            options.headers = headers
        }

        return instance.post('/goods/search_goods', data, options)
    },

    goods_detail(data,headers)
    {
        let options = {}

        if (headers) {
            options.headers = headers
        }

        return instance.post('/goods/goods_detail', data, options)
    },

    check_user(data,headers)
    {
        let options = {}

        if (headers) {
            options.headers = headers
        }

        return instance.post('/mobile/check_user', data, options)
    },

    get_user(data,headers)
    {

        let options = {}

        if (headers) {
            options.headers = headers
        }

        return instance.get('http://www.qkvop.com/admin/public/index.php/api/dashboard/statistics', data, options)

    }



}